(function (angular) {
  "use strict";

  angular
    .module("app")
    .controller(
      "pickFeaturedPromotionController",
      pickFeaturesPromotionController,
    );

  pickFeaturesPromotionController.$inject = [
    "$uibModalInstance",
    "PromotionsApi",
  ];

  function pickFeaturesPromotionController($uibModalInstance, PromotionsApi) {
    var vm = this;

    // properties
    vm.isLoading = false;
    vm.posts = {};
    vm.filters = {
      type: "promotion",
      status: "approved",
      title: "",
      page: 1,
    };

    // methods
    vm.dismiss = $uibModalInstance.dismiss;
    vm.getPromotions = getPromotions;
    vm.pickPromotion = pickPromotion;

    /**
     * Retrieves promotions from the API
     * @return {void}
     */
    function getPromotions() {
      vm.isLoading = true;
      PromotionsApi.get(
        vm.filters,
        function handlePromotionsResponse(response) {
          vm.promotions = response;
          vm.isLoading = false;
        },
        function handlePromotionsError() {
          vm.isLoading = false;
        },
      );
    }

    /**
     * Returns the chosen promotion to parent controller
     * @param  {object} post - API promotion object
     * @return {void}
     */
    function pickPromotion(post) {
      $uibModalInstance.close(post);
    }

    getPromotions();
  }
})(angular);
